import { useEffect } from 'react';
import whatisIcon from '../assets/whatis.jpg'
import types from '../assets/types.jpg'
import process from '../assets/proces.jpg'
import AOS from 'aos';
import 'aos/dist/aos.css';
import Navbar from './navbar';
import Footer from './footer';


function HomePage() {
  useEffect(() => {
    AOS.init({
      duration: 1200,
      once: true,
    });
  }, []);
  return (
    <div className='text-white  font-poppins  '>
      {/* Navigation Bar */}
      <Navbar />
      {/* Main Section */}
      <main className="main bg-hero-pattern bg-cover h-[100dvh]">
        <div className="flex h-full  items-center justify-center content-center flex-col" data-aos="fade-up">
          <h1 className="title text-8xl 3xs:text-3xl 3xs:text-center font-extrabold" data-aos="zoom-in">Welcome to MBR Legal Associates</h1>
          <p className="subtitle text-lg 2xs:text-sm mt-4  text-center" data-aos="fade-up" data-aos-delay="300">
            Your One-Stop Solution for Licences and Registrations
          </p>
          <a
            href="/Services"
            className="btn-primary mt-8 inline-block border-2 border-white py-4 px-6 rounded-full hover:bg-orange-600 transition"
            data-aos="fade-up" data-aos-delay="500"
          >
            Explore Services
          </a>
        </div>
      </main>

      <section className="mt-10 3xs:px-4 px-20" data-aos="fade-right">
        <h1 className="text-3xl font-bold flex justify-center text-black mb-4 3xs:text-xl">
          What Is a Food Licence?
        </h1>
        <p className="text-slate-950 text-lg 3xs:text-sm" data-aos="fade-left" data-aos-delay="300">
          A food licence is a mandatory legal document required for businesses involved in the manufacturing, distribution, or sale of food products. It ensures that the food served or sold complies with health and safety regulations to protect consumer well-being.
        </p>
        <div className="px-7 py-4 mb-6 3xs:px-9">
          <h2 className="text-2xl font-semibold text-gray-900 mb-3 3xs:text-lg">Why Is It Important?</h2>
          <div className="mt-8 flex flex-wrap-reverse justify-between 3xs:flex-row">
            <ul className="list-disc pl-5 3xs:mt-6 md:mt-0  text-slate-950 3xs:pl-4 3xs:mb-4">
              <li>Ensures food safety and hygiene standards.</li>
              <li>Builds trust and credibility with customers.</li>
              <li>Complies with legal requirements to avoid penalties.</li>
              <li>Promotes transparency in the food business.</li>
            </ul>
            <img
  src={whatisIcon}
  alt="What Is Food Licence Icon"
  className="rounded-lg h-[300px] w-[450px] 3xs:h-[300px] 3xs:w-90 shadow-orange-glow"
/>

          </div>
        </div>

        <div className="px-7 py-4 mb-63xs:px-9" data-aos="fade-up">
          <h1 className="text-3xl font-bold flex justify-center text-black mb-4 3xs:text-xl">
            Types of Food Licenses
          </h1>
          <p className="text-slate-950 text-lg 3xs:text-sm" data-aos="fade-up" data-aos-delay="300">
            Different types of food licenses are issued based on the size and nature of the food business.
          </p>
          <div className="mt-8 flex flex-wrap-reverse justify-between 3xs:flex-row">
          <img
  src={types}
  alt="License Icon"
  className="rounded-lg h-[300px] w-[450px] 3xs:h-[300px] 3xs:w-90 shadow-orange-glow"
  data-aos="flip-left"
/>

            <ul
              className="list-disc pl-6 mt-4 space-y-2  3xs:mt-6 md:mt-0  text-gray-900 3xs:pl-4"
              data-aos="fade-left"
              data-aos-delay="500"
            >
              <li>Basic FSSAI Registration for small-scale food businesses.</li>
              <li>State Food License for medium-sized businesses operating within a state.</li>
              <li>Central Food License for large-scale businesses or those operating in multiple states.</li>
            </ul>
          </div>
        </div>

        <div className="px-7 py-6 mb-8 3xs:px-9">
          <h1 className="text-3xl font-bold text-center text-gray-800 mb-6 3xs:text-xl">
            Food Licensing Process in Telangana
          </h1>
          <p className="text-slate-950 text-lg mb-4 3xs:text-sm">
            The food licensing process involves several steps to ensure that businesses comply with food safety standards and regulations. Here’s a general overview:
          </p>
          <div className="flex flex-wrap justify-between mt-8 3xs:flex-row">
            <ol className="list-decimal pl-8  3xs:mt-6 md:mt-0  space-y-3 text-gray-900 3xs:pl-4">
              <li>Determine the type of food license required (Basic, State, or Central).</li>
              <li>Register your business on the FSSAI online portal.</li>
              <li>Fill out the application form and upload necessary documents.</li>
              <li>Pay the applicable fees based on the license type.</li>
              <li>Inspection by the concerned authority (if applicable).</li>
              <li>Receive the license upon approval from the authorities.</li>
            </ol>
            <img
              src={process}
              alt="What Is Food Licence Icon"
              className="rounded-lg h-[300px] w-[450px] 3xs:h-[300px] 3xs:w-90 shadow-orange-glow"
              />
          </div>
        </div>

        <div className="px-7 py-6 mb-8 3xs:px-9">
          <h1 className="text-3xl font-bold text-center text-slate-950 mb-6 3xs:text-xl">
            FAQs on Food License in Telangana
          </h1>
          <div className="space-y-6">
            <div>
              <h2 className="text-xl font-semibold text-gray-900 3xs:text-lg">
                1. Who needs a food license in Telangana?
              </h2>
              <p className="text-slate-950 mt-2 3xs:text-sm">
                Any business involved in food manufacturing, processing, packaging, storage, or distribution is required to obtain a food license under FSSAI regulations.
              </p>
            </div>

            <div>
              <h2 className="text-xl font-semibold text-gray-900 3xs:text-lg">
                2. What documents are required for obtaining a food license?
              </h2>
              <p className="text-slate-950 mt-2 3xs:text-sm">
                Documents like identity proof, business registration certificates, proof of premises ownership, and a food safety management plan are generally required.
              </p>
            </div>

            <div>
              <h2 className="text-xl font-semibold text-gray-900 3xs:text-lg">
                3. How long does it take to get a food license?
              </h2>
              <p className="text-slate-950 mt-2 3xs:text-sm">
                The processing time for a food license typically takes 15 to 30 days, depending on the type of license and the completeness of the submitted documents.
              </p>
            </div>

            <div>
              <h2 className="text-xl font-semibold text-gray-900 3xs:text-lg">
                4. What is the validity of a food license?
              </h2>
              <p className="text-slate-950 mt-2 3xs:text-sm">
                A food license is valid for 1 to 5 years, depending on the tenure selected during the application process. Renewal should be done before the expiry date.
              </p>
            </div>
          </div>
        </div>

        <div className="mt-10 px-7 py-4 text-center 3xs:px-9">
          <h2 className="text-3xl font-semibold text-slate-950 3xs:text-xl">Conclusion</h2>
          <p className="text-lg text-slate-950 mt-4 3xs:text-sm">
            This concludes the overview of the Food License process. Having the proper license ensures safety, legality, and trust in your food business. If you are ready to apply, contact us for more information.
          </p>
        </div>
      </section>

      <Footer />

    </div>
  );
}
export default HomePage;






